import { ADVERTISING_INDEX_FIELDS } from 'src/utils/entityDefinitions/indexes/advertisingIndexDefinitions';
import { ATLAS_INDEX_FIELDS } from 'src/utils/entityDefinitions/indexes/atlasIndexDefinitions';
import { BEACON_INDEX_FIELDS } from 'src/utils/entityDefinitions/indexes/beaconIndexDefinitions';
import { OMNI_INDEX_FIELDS } from 'src/utils/entityDefinitions/indexes/omniIndexDefinitions';

export { ADVERTISING_INDEX_FIELDS, ATLAS_INDEX_FIELDS, BEACON_INDEX_FIELDS, OMNI_INDEX_FIELDS };
